import { render, staticRenderFns } from "./OtherOccasions.vue?vue&type=template&id=5f68549c&"
import script from "./OtherOccasions.vue?vue&type=script&lang=js&"
export * from "./OtherOccasions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports